import { Typography } from '@mui/material'

import notifyAllImage from "./images/notify-all.png"
import synchroniseImage from "./images/synchronise.png"
import archiveImage from "./images/archive.png"

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Pass details</Typography>
      <p>Here you can see details about your pass.</p>
      <p>On the left you see similar information to what you saw in the passes list, plus a few extra details</p>

      <p>Below the details is a form where you can change expiry date or synchronise the pass with recent template changes.</p>

      <Typography variant='h5' className='pt-10 pb-5'>Pass preview</Typography>
      <p>On the right (or below if you have a narrow browser window) you'll see a preview of the pass
        in both Apple and Google formats. These are an as accurate represenation of what the passes look like
        on actual Apple and Google devices as possible.</p>

      <Typography variant='h5' className='pt-10 pb-5'>Sub-menu</Typography>
      <p>Across the top you'll find some new menu items. You can find some help by clicking through to a new page
        and opening help there.
      </p>
    </div>
  )
}

export default HelpText